import React from 'react';
import {Row,Col,Typography} from 'antd';
import {AiOutlineWarning} from 'react-icons/ai'
import './requestcard.css';
import moment from "moment";


const RequestCard=(props)=>{
    const {Text} = Typography
return(
    <Col className='request-card-main'>
        <div className='request-card-title'>
        <AiOutlineWarning className='request-card-title-icon'/>
        <Text className='request-card-title-text'> You sent request for correction</Text>
        </div>
        <div className='request-card-details'>
            <div className='deatil'>Date </div> <div className='deatil-value'>{moment(props.Date).format('MMMM DD,YYYY')}</div>
        </div>
        <div className='request-card-details'>
            <div className='deatil'>Start Time </div> <div className='deatil-value'>{props.StartTime}</div>
        </div>
        <div className='request-card-details'>
            <div className='deatil'>End Time</div> <div className='deatil-value'>{props.EndTime}</div>
        </div>
        <div>
            <div className='deatil'>Reason for correction</div>
            <p className='detail-para'>
              {props.Reason}
            </p>
        </div>
    </Col>
)
}
export default RequestCard